<template lang="pug">
Suspense
  .native-app-workouts-screen.rogue-scroll-y#WS-workouts-screen(:class="{'centered': loading, 'dark-mode': isDarkMode}")
    NativeAppSpinnerWrapper#WS-workouts-spinner(:active="loading")
      NativeAppListItem#WS-workout-history-item(@click="navigateToWorkoutHistory" iconName="history" :iconFillColor="isDarkMode ? 'white' : 'black'" v-if="!loading && !rogue.isApp('4.6.0')")
        .details
          .title#WS-workout-history-title {{ workoutHistoryTitle }}
          .subtitle#WS-workout-history-subtitle {{ workoutHistorySubtitle }}
      WorkoutStatistics#WS-workout-statistics(ref="stats")
</template>

<script setup lang="ts">
import { computed, onMounted, ref, useTemplateRef, watch } from 'vue'
import { useRoute } from 'vue-router'
import NativeAppListItem from './components/native-app-list-item.vue'
import NativeAppSpinnerWrapper  from './components/native-app-spinner-wrapper.vue'
import { useRogue } from '@/js/services/Rogue'
import WorkoutStatistics from '@/js/pages/account/subroutes/workouts/WorkoutStatistics.vue'
import { messages } from '@/js/app-bridge/messages'
import { useUIStore } from '@/js/stores/uiStore'

const rogue = useRogue()
const uiStore = useUIStore()
const route = useRoute()

const workoutHistoryTitle = computed(() => rogue.__('Workout History'))
const workoutHistorySubtitle = computed(() => rogue.__('View your recorded workout logs and metrics in detail.'))

const isDarkMode = computed<boolean>(() => route.query.theme === 'dark')

const loading = ref<boolean>(true)
const workoutStatistics = useTemplateRef<typeof WorkoutStatistics>('stats')

const lastContentReloadAt = computed<number>(() => uiStore.appLastContentReloadAt || Date.now())

function refreshData() {
  uiStore.appLastContentReloadAt = Date.now()
}

function navigateToWorkoutHistory() {
  rogue.emitToApp(messages.OPEN_SCREEN, { screen: 'Logbook' })
}

watch(lastContentReloadAt, async (curr, prev) => {
  if (curr > prev) {
    loading.value = true
    await workoutStatistics.value?.load()
    loading.value = false
  }
})

onMounted(async () => {
  await refreshData()
})
</script>

<style scoped lang="scss">
.native-app-workouts-screen {
  padding: $space-s;
  padding-top: $space-m;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  &.centered {
    justify-content: center;
  }

  &.dark-mode {
    background-color: $color-black;
    color: $color-white;

    .details {
      .title {
        color: $color-white;
      }
    }
  }
}

:deep(.native-app-list-item) {
  margin-top: 0;
  margin-bottom: $space-m;
  padding: $space-s;
  border: 1px solid #d2d2d2;
}

.details {
  display: flex;
  flex-direction: column;
  gap: $space-xxxs;

  .title {
    font-size: $size-s;
    font-weight: bold;
  }
  .subtitle {
    font-size: $size-xs;
    line-height: $size-s;
    color: $color-gray-dark;
  }
}
</style>
